import { Chip, Theme, Typography, useMediaQuery } from "@mui/material";
// import styled from "@mui/material/styles/styled";
import React, { Fragment, useEffect, useState } from "react";
import {
  downloadCSV,
  ExportButton,
  InputProps,
  List,
  NumberInput,
  ReferenceInput,
  SearchInput,
  SelectInput,
  TopToolbar,
  useListContext,
  usePermissions,
  useTranslate,
} from "react-admin";
import {
  getCachedMenuStats,
  isMenuStatsCacheExpired,
  preloadMenuStats,
} from "../layout/PreloadMenuStats";
import CustomExportButton from "../unit/CustomExportButton";
import CustomFilterButton from "../unit/CustomFilterButton";
import CustomFilterText from "../unit/CustomFilterText";
import CustomLoading from "../unit/CustomLoading";
import FilterAmountOriginalPrincipal from "../unit/FilterAmountOriginalPrincipal";
import FilterAmountPrincipal from "../unit/FilterAmountPrincipal";
import FilterBank from "../unit/FilterBank";
import FilterChargedOffDate from "../unit/FilterChargedOffDate";
import FilterCustomSelect from "../unit/FilterCustomSelect";
import FilterErrorLoanStatus from "../unit/FilterErrorLoanStatus";
import FilterLastPaymentDate from "../unit/FilterLastPaymentDate";
import FilterLoanAttention from "../unit/FilterLoanAttention";
import FilterLoanResetHistory from "../unit/FilterLoanResetHistory";
import FilterMaturityDate from "../unit/FilterMaturityDate";
import FilterNoteDate from "../unit/FilterNoteDate";
import FilterPaidOffDate from "../unit/FilterPaidOffDate";
import FilterPaymentFrequency from "../unit/FilterPaymentFrequency";
import FilterProduct from "../unit/FilterProduct";
import FilterRemainingTerm from "../unit/FilterRemainingTerm";
import FilterVoidedDate from "../unit/FilterVoidedDate";
import formatDate from "../unit/formatDate";
import getFiltersFromURL from "../unit/getFiltersFromURL";
import HmLoading from "../unit/HmLoading";
import HmPageHeaderTitle from "../unit/HmPageHeaderTitle";
import NoResults from "../unit/NoResults";
import PostPagination from "../unit/PostPagination";
import { ShowListTotal } from "../unit/ShowListTotal";
import useNotify from "../unit/useNotify";
import DefaultLoanList from "./DefaultLoanList";
import LoanListAside from "./LoanListAside";
import NoPermission from "../unit/NoPermission";
const LoanListBulkActions = () => (
  <Fragment>
    <ExportButton />
  </Fragment>
);
const LoanFilterList = () => {
  const listContext = useListContext();
  const { filterValues } = listContext;
  const { total, data, isPending, isLoading, isFetching } = useListContext();
  if (isPending)
    return (
      <Typography sx={{ p: 5 }} className="hm-list-datagrid">
        pending...
      </Typography>
    );
  if (isFetching)
    return (
      <Typography sx={{ p: 5 }} className="hm-list-datagrid">
        loading ...
      </Typography>
    );
  if (!total || total === 0) {
    return (
      <Typography sx={{ p: 5 }} className="hm-list-datagrid no-results">
        <NoResults />
      </Typography>
    );
  }
  return (
    <>
      <DefaultLoanList
        filterStatus={filterValues.status}
        curStatus={filterValues?.curStatus}
      />
      <CustomLoading />
    </>
  );
};

const LoanListActions = () => {
  // const { total } = useListContext();
  // const { permissions } = usePermissions();
  const listContext = useListContext();
  // const { filterValues } = listContext;

  return (
    <TopToolbar sx={{ width: "100%" }}>
      <CustomFilterButton />
      <CustomExportButton />
    </TopToolbar>
  );
};

function CustomAttentionFieldFun(
  iTransferFailedNumber: any,
  iInsufficientBalanceCheckNumber: any,
  iTransferFatalErrorNumber: any
) {
  const transferFailedNumber = iTransferFailedNumber;
  const insufficientBalanceCheckNumber = iInsufficientBalanceCheckNumber;
  const transferFatalErrorNumber = iTransferFatalErrorNumber;

  let errorValue = [];
  if (transferFailedNumber >= 2) {
    errorValue.push("Transfer Failed");
  }
  if (insufficientBalanceCheckNumber >= 2) {
    errorValue.push("Insufficient Balance");
  }
  if (transferFatalErrorNumber >= 1) {
    errorValue.push("Funding Source Removed");
  }
  const errorValueStr = errorValue.join(", ");
  return errorValueStr;
}

const customLoanTypeExporter = (records: any) => {
  let filterStatus = "";
  if (records.length > 0) {
    filterStatus = records[0].sStatus;
  }
  if (filterStatus == "Funded") {
    filterStatus = "Active";
  }

  let data = [];
  let title = {};

  if (filterStatus == "Voided") {
    data = records.map((record: any) => {
      const {
        id,
        sLoanNum,
        sProductName,
        sFirstName,
        sLastName,
        coapplication_name,
        dNoteDate,
        dMaturityDate,
        sOriginalNoteAmount,
        sActivePrincipalBalance,
        sPaymentFrequency,
        sComment,
        updated_status_at,
        sOper,
        iApplicationId,
      } = record;
      return {
        sLoanNum,
        sProductName,
        fullname: sFirstName + " " + sLastName + " " + coapplication_name,
        dNoteDate: formatDate(dNoteDate),
        dMaturityDate: formatDate(dMaturityDate),
        sOriginalNoteAmount,
        sActivePrincipalBalance,
        sPaymentFrequency,
        sComment: '"' + sComment + '"', // add double quote to comment
        updated_status_at: formatDate(updated_status_at),
        sOper,
        iApplicationId,
      };
    });
    title = {
      sLoanNum: "Loan #",
      sProductName: "Product",
      fullname: "Borrower",
      dNoteDate: "Note Date",
      dMaturityDate: "Maturity Date",
      sOriginalNoteAmount: "Original Principal Amount",
      sActivePrincipalBalance: "Remaining Principal Amount",
      sPaymentFrequency: "Payment Frequency",
      sComment: "Voided Reason",
      updated_status_at: "Date Voided",
      sOper: "Voided By",
      id: "App #",
    };
  } else if (filterStatus == "Charged-Off") {
    data = records.map((record: any) => {
      const {
        id,
        sLoanNum,
        sProductName,
        sFirstName,
        sLastName,
        coapplication_name,
        dNoteDate,
        dMaturityDate,
        sOriginalNoteAmount,
        sActivePrincipalBalance,
        sPaymentFrequency,
        sAmountChargedOff,
        updated_status_at,
        allModifyNum,
        iApplicationId,
      } = record;
      return {
        sLoanNum,
        sProductName,
        fullname: sFirstName + " " + sLastName + " " + coapplication_name,
        dNoteDate: formatDate(dNoteDate),
        dMaturityDate: formatDate(dMaturityDate),
        sOriginalNoteAmount,
        sActivePrincipalBalance,
        sPaymentFrequency,
        sAmountChargedOff,
        updated_status_at: formatDate(updated_status_at),
        allModifyNum,
        iApplicationId,
      };
    });
    title = {
      sLoanNum: "Loan #",
      sProductName: "Product",
      fullname: "Borrower",
      dNoteDate: "Note Date",
      dMaturityDate: "Maturity Date",
      sOriginalNoteAmount: "Original Principal Amount",
      sActivePrincipalBalance: "Remaining Principal Amount",
      sPaymentFrequency: "Payment Frequency",
      sAmountChargedOff: "Charged-Off Amount",
      updated_status_at: "Date Charged-Off",
      allModifyNum: "Reset History",
      id: "App #",
    };
  } else if (filterStatus == "Paid-Off") {
    data = records.map((record: any) => {
      const {
        id,
        sLoanNum,
        sProductName,
        sFirstName,
        sLastName,
        coapplication_name,
        dNoteDate,
        dMaturityDate,
        sOriginalNoteAmount,
        sActivePrincipalBalance,
        sPaymentFrequency,
        sAmountChargedOff,
        updated_status_at,
        allModifyNum,
        iApplicationId,
      } = record;
      return {
        sLoanNum,
        sProductName,
        fullname: sFirstName + " " + sLastName + " " + coapplication_name,
        dNoteDate: formatDate(dNoteDate),
        dMaturityDate: formatDate(dMaturityDate),
        sOriginalNoteAmount,
        sActivePrincipalBalance,
        sPaymentFrequency,
        sAmountChargedOff,
        updated_status_at: formatDate(updated_status_at),
        allModifyNum,
        iApplicationId,
      };
    });
    title = {
      sLoanNum: "Loan #",
      sProductName: "Product",
      fullname: "Borrower",
      dNoteDate: "Note Date",
      dMaturityDate: "Maturity Date",
      sOriginalNoteAmount: "Original Principal Amount",
      sActivePrincipalBalance: "Remaining Principal Amount",
      sPaymentFrequency: "Payment Frequency",
      sAmountChargedOff: "Paid-Off Amount",
      updated_status_at: "Date Paid-Off",
      allModifyNum: "Reset History",
      id: "App #",
    };
  } else {
    data = records.map((record: any) => {
      const {
        id,
        sLoanNum,
        sProductName,
        sFirstName,
        sLastName,
        coapplication_name,
        dNoteDate,
        dMaturityDate,
        sOriginalNoteAmount,
        sActivePrincipalBalance,
        sPaymentFrequency,
        curStatus,
        iTransferFailedNumber,
        iInsufficientBalanceCheckNumber,
        iTransferFatalErrorNumber,
        allModifyNum,
        iApplicationId,
      } = record;
      return {
        sLoanNum,
        sProductName,
        fullname: sFirstName + " " + sLastName + " " + coapplication_name,
        dNoteDate: formatDate(dNoteDate),
        dMaturityDate: formatDate(dMaturityDate),
        sOriginalNoteAmount,
        sActivePrincipalBalance,
        sPaymentFrequency,
        curStatus,
        attention: CustomAttentionFieldFun(
          iTransferFailedNumber,
          iInsufficientBalanceCheckNumber,
          iTransferFatalErrorNumber
        ),
        allModifyNum,
        iApplicationId,
      };
    });
    title = {
      sLoanNum: "Loan #",
      sProductName: "Product",
      fullname: "Borrower",
      dNoteDate: "Note Date",
      dMaturityDate: "Maturity Date",
      sOriginalNoteAmount: "Original Principal Amount",
      sActivePrincipalBalance: "Remaining Principal Amount",
      sPaymentFrequency: "Payment Frequency",
      curStatus: "Status",
      attention: "Attention",
      allModifyNum: "Reset History",
      id: "App #",
    };
  }

  return {
    title: title,
    data: data,
    filterStatus: filterStatus,
  };
};
function customLoanFilterText(
  filter_status: string,
  filter_curStatus: string,
  filter_filterRemainingterm: string
) {
  let filterText = "_";
  if (filter_curStatus == "Funding Source Removed") {
    filterText += "Funding Source Removed";
  } else if (filter_curStatus == "Insufficient Balance") {
    filterText += "Insufficient Balance";
  } else if (filter_curStatus == "Transfer Failed") {
    filterText += "Transfer Failed";
  } else if (filter_curStatus == "large30D") {
    filterText += "Delinquent over 30 Days";
  } else if (filter_curStatus == "Late") {
    filterText += "Delinquent under 30 Days";
  } else if (filter_curStatus == "OK6") {
    filterText += "Current with over 6 Resets";
  } else if (filter_curStatus == "OK36") {
    filterText += "Current with 3-6 Resets";
  } else if (filter_curStatus == "OK3") {
    filterText += "Current with under 3 Resets";
  } else if (filter_curStatus == "OK") {
    if (filter_filterRemainingterm == "<12 Months") {
      filterText += "Current with 0 Resets (Maturing in 12 M)";
    } else if (filter_filterRemainingterm == "12-24 Months") {
      filterText += "Current with 0 Resets (Maturing in 12-24 M)";
    } else if (filter_filterRemainingterm == "24-36 Months") {
      filterText += "Current with 0 Resets (Maturing in 24-36 M)";
    } else if (filter_filterRemainingterm == "36-48 Months") {
      filterText += "Current with 0 Resets (Maturing in 36-48 M)";
    } else if (filter_filterRemainingterm == "48-60 Months") {
      filterText += "Current with 0 Resets (Maturing in 48-60 M)";
    } else if (filter_filterRemainingterm == ">60 Months") {
      filterText += "Current with 0 Resets (Maturing in over 60 M)";
    }
  }
  if (filter_status == "Charged-Off") {
    filterText += "Charged-Off Last 12 Months";
  } else if (filter_status == "Paid-Off") {
    filterText += "Paid-Off Last 12 Months";
  } else if (filter_status == "Voided") {
    filterText += "Voided Last 12 Months";
  }
  return filterText;
}
const customLoanExporter = (records: any, fetchRelatedRecords: any) => {
  const filterData = customLoanTypeExporter(records);
  //{{{
  const currentFilters = getFiltersFromURL();
  const filter_status = currentFilters?.status;
  const filter_curStatus = currentFilters?.curStatus;
  const filter_filterRemainingterm = currentFilters?.filterRemainingterm;
  const otherFilters = { ...currentFilters };
  delete otherFilters.status;
  delete otherFilters.curStatus;
  delete otherFilters.filterRemainingterm;
  const filterString = Object.entries(otherFilters)
    .map(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        if (key == "id") {
          key = "AppId";
        }
        return `[${getFieldTitle(key)} ${getFieldValueType(
          key
        )} "${getFieldValue(key, value)}"]`;
      }
      return "";
    })
    .filter(Boolean)
    .join("");

  console.log("Filter string:", filterString);
  ///}}}

  let csvTitle = filterData.title;
  let data = filterData.data;
  let filterStatus = filterData.filterStatus;
  const csvData = [{ ...csvTitle }, ...data];
  const csvDataStr = csvData.map((row) => Object.values(row).join(","));
  let filename = "Loans";
  filename += customLoanFilterText(
    filter_status,
    filter_curStatus,
    filter_filterRemainingterm
  );

  if (filterString) {
    csvDataStr.push("");
    csvDataStr.push("Filters Applied:" + filterString);
  }
  downloadCSV(csvDataStr.join("\n"), filename);
};

function getFieldTitle(field: string) {
  const titleMap = {
    id: "App #",
    iUserId: "User #",
    sLoanNum: "Loan #",
    product: "Product",
    userName: "Applicant Name",
    userEmail: "Applicant Email",
    filterLoanStatus: "Status",
    originalnoteamount: "Original Principal Amount",
    activeprincipalbalance: "Remaining Principal Amount",
    limitLastPaymentDate: "Last Payment Date",
    limitNoteDate: "Note Date",
    limitMaturityDate: "Maturity Date",
    paymentfrequency: "Payment Frequency",
    remainingterm: "Remaining Term",
    attention: "Attention",
    allModifyNum: "Reset History",
    coName: "Co-Applicant Name",
    guarantorName: "Guarantor Name",
    amountSubmit: "Amount Applied",
    amountReview: "Amount Offered",
    decision: "Decision",
    PrimaryPortfolio: "Primary Portfolio",
    SecondaryPortfolio: "Secondary Portfolio",
    counselor: "Referring Counselor",
    employer: "Referring Employer",
    referralVerify: "Verification Status",
    appFees: "Application Fees Status",
    borrowerAgreement: "Borrower Agreement",
    sApplicationResponse: "Borrower Acceptance",
    sBank: "Search Bank",
  };
  return titleMap[field] || field;
}
function getFieldValueType(field: string) {
  const titleMap = {
    id: "contains",
    iUserId: "contains",
    sLoanNum: "contains",
    product: "is",
    userName: "contains",
    userEmail: "contains",
    filterLoanStatus: "is",
    originalnoteamount: "in",
    activeprincipalbalance: "in",
    limitLastPaymentDate: "is",
    limitNoteDate: "is",
    limitMaturityDate: "is",
    paymentfrequency: "is",
    remainingterm: "in",
    attention: "is",
    allModifyNum: "is",
    PrimaryPortfolio: "is",
    coName: "contains",
    guarantorName: "contains",
    amountSubmit: "in",
    amountReview: "in",
    decision: "is",
    counselor: "contains",
    employer: "contains",
    referralVerify: "is",
    appFees: "is",
    borrowerAgreement: "is",
    sApplicationResponse: "is",
  };
  return titleMap[field] || "is";
}

function getFieldValue(field: string, value: any) {
  if (
    field == "originalnoteamount" ||
    field == "activeprincipalbalance" ||
    field == "amountSubmit"
  ) {
    if (value == "1") {
      return "<$1000";
    } else if (value == "2") {
      return "$1000-$5000";
    } else if (value == "3") {
      return "$5000-$10,000";
    } else if (value == "4") {
      return "$10,000-$20,000";
    } else if (value == "5") {
      return ">$20,000";
    }
  } else if (field == "limitLastPaymentDate") {
    if (value == "last_years_ago") {
      return "≥ 1 Year Ago";
    } else {
      return value;
    }
  } else if (field == "limitNoteDate") {
    if (value == "current") {
      return "Current Year";
    } else if (value == "last1") {
      return "Last Year";
    } else if (value == "last2_3") {
      return "Last 2-3 Years";
    } else if (value == "last3_5") {
      return "Last 3-5 Years";
    } else if (value == "last5") {
      return "> 5 Years Ago";
    }
  } else if (field == "limitMaturityDate") {
    if (value == "current") {
      return "Current Year";
    } else if (value == "next1") {
      return "Next Year";
    } else if (value == "next2_3") {
      return "Next 2-3 Years";
    } else if (value == "next3_5") {
      return "Next 3-5 Years";
    } else if (value == "next5") {
      return "> 5 Years Later";
    }
  } else if (field == "attention") {
    if (value == "transferFailedNumber") {
      return "Transfer Failed";
    } else if (value == "insufficientBalanceCheckNumber") {
      return "Insufficient Balance";
    } else if (value == "transferFatalErrorNumber") {
      return "Funding Source Removed";
    }
  } else {
    return value;
  }
}
const LoanListTitle = () => {
  const listContext = useListContext();
  const { filterValues } = listContext;
  return (
    <>
      {filterValues.status == "Charged-Off" && (
        <HmPageHeaderTitle
          title="Charged-Off"
          totalNumber={<ShowListTotal onlyShowNumber={true} />}
        />
      )}
      {filterValues.status == "Voided" && (
        <HmPageHeaderTitle
          title="Voided"
          totalNumber={<ShowListTotal onlyShowNumber={true} />}
        />
      )}
      {filterValues.status == "Paid-Off" && (
        <HmPageHeaderTitle
          title="Paid-Off"
          totalNumber={<ShowListTotal onlyShowNumber={true} />}
        />
      )}
      {(filterValues.status == "active" || filterValues.status == "") && (
        <HmPageHeaderTitle
          title="Active"
          totalNumber={<ShowListTotal onlyShowNumber={true} />}
        />
      )}
    </>
  );
};

const LoanList = () => {
  // const isSmall = useMediaQuery<Theme>((theme) => theme.breakpoints.down("md"));
  // const { successNotify, errorNotify, infoNotify } = useNotify();
  // const [record, setRecord] = useState<{ total: number } | null>(null);
  const permissions =
    localStorage.getItem("bbaccess")?.toString().split(",") || [];
  if (!permissions.includes("personal_loans")) {
    return <NoPermission />;
  }

  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  // const [primarySubPortfolioOptionList, setPrimarySubPortfolioOptionList] =
  //   React.useState<{ label: string; value: any }[]>([]);
  // const [secondarySubPortfolioOptionList, setSecondarySubPortfolioOptionList] =
  //   React.useState<{ label: string; value: any }[]>([]);
  // const [primaryPortfolioValue, setPrimaryPortfolioValue] = React.useState("");
  // const [primarySubPortfolioValue, setPrimarySubPortfolioValue] =
  //   React.useState("");
  // const [secondaryPortfolioValue, setSecondaryPortfolioValue] =
  //   React.useState("");
  // const [secondarySubPortfolioValue, setSecondarySubPortfolioValue] =
  //   React.useState("");
  let primaryportfolio = new Array();
  let secondaryportfolio = new Array();
  const localBank = localStorage.getItem("bank") || "";
  const authrole = localStorage.getItem("authrole") || "";
  if (localBank == "nolb" || authrole == "admin") {
    primaryportfolio["DAF1"] = new Array();
    primaryportfolio["DAF2"] = new Array();
    primaryportfolio["DAF3"] = new Array();
  }
  if (localBank == "ircceo" || authrole == "admin") {
    primaryportfolio["RV027-ORR"] = new Array();
    primaryportfolio["RV027-ORR"].push("GH200");
    primaryportfolio["RV027-ORR"].push("2023 Fresh Start Fund");
    primaryportfolio["RV100 Unrestricted"] = new Array();
    primaryportfolio["RV100 Unrestricted"].push("U2000");
    primaryportfolio["RV100 Unrestricted"].push("2023 Fresh Start Fund");
    primaryportfolio["Resilience Loans"] = new Array();
    primaryportfolio["Resilience Loans"].push("Resilience Loans");
    primaryportfolio["Resilience Loans"].push("2023 Fresh Start Fund");
    primaryportfolio["RG200 CDFI General"] = new Array();
    primaryportfolio["RG200 CDFI General"].push("GG100");
    primaryportfolio["RG200 CDFI General"].push("RG200-CDFI General");
    primaryportfolio["RG200 CDFI General"].push("2023 Fresh Start Fund");
    primaryportfolio["RIN SIF"] = new Array();
    primaryportfolio["RIN SIF"].push("RIN SIF");
    primaryportfolio["RIN SIF"].push("2023 Fresh Start Fund");
    primaryportfolio["RV201 CDFI 2019"] = new Array();
    primaryportfolio["RV201 CDFI 2019"].push("RV201 CDFI 2019");
    primaryportfolio["RV201 CDFI 2019"].push("2023 Fresh Start Fund");
    primaryportfolio["RV202 CDFI 2021"] = new Array();
    primaryportfolio["RV202 CDFI 2021"].push("RV202 CDFI 2021");
    primaryportfolio["RV202 CDFI 2021"].push("2023 Fresh Start Fund");
    primaryportfolio["RV203 CDFI COVID"] = new Array();
    primaryportfolio["RV203 CDFI COVID"].push("RV203 CDFI COVID");
    primaryportfolio["RV203 CDFI COVID"].push("2023 Fresh Start Fund");
    primaryportfolio["SBA"] = new Array();
    primaryportfolio["SBA"].push("SBA");
    primaryportfolio["SBA"].push("2023 Fresh Start Fund");
    primaryportfolio["SAFE"] = new Array();
    primaryportfolio["SAFE"].push("SAFE");
    primaryportfolio["SAFE"].push("RV203 - CDFI COVID T1");
    primaryportfolio["SAFE"].push("2023 Fresh Start Fund");
    primaryportfolio["Fresh Start Fund"] = new Array();
    primaryportfolio["Fresh Start Fund"].push("2023 Fresh Start Fund");
    primaryportfolio["FSF 2023"] = new Array();
    primaryportfolio["FSF 2023"].push("2023 Fresh Start Fund");
    primaryportfolio["FSF 2023"].push("Other");
    primaryportfolio["General"] = new Array();
    primaryportfolio["General"].push("RIN SIF");
    primaryportfolio["General"].push("CDFI");
    primaryportfolio["General"].push("Other");
    primaryportfolio["Other"] = new Array();
    primaryportfolio["Other"].push("2023 Fresh Start Fund");
    primaryportfolio["Other"].push("Other");

    secondaryportfolio["Auto Loans"] = new Array();
    secondaryportfolio["Auto Loans"].push("Auto");
    secondaryportfolio["Business Loans"] = new Array();
    secondaryportfolio["Business Loans"].push("Business ORR");
    secondaryportfolio["Business Loans"].push("Business RF-General");
    secondaryportfolio["Business Loans"].push("Business RF-ORR");
    secondaryportfolio["Business Loans"].push("Business-General");
    secondaryportfolio["Business Loans"].push("Child Care-General");
    secondaryportfolio["Business Loans"].push("Child Care-ORR");
    secondaryportfolio["Business Loans"].push("Whole Planet 2023");
    secondaryportfolio["Business Loans"].push("SBA");
    secondaryportfolio["Credit Building Loans"] = new Array();
    secondaryportfolio["Credit Building Loans"].push("PSP-Credit Building");
    secondaryportfolio["Credit Building Loans"].push(
      "Credit Building -General"
    );
    secondaryportfolio["Credit Building Loans"].push("Credit Building ORR");
    secondaryportfolio["Education Loans"] = new Array();
    secondaryportfolio["Education Loans"].push("Education loan");
    secondaryportfolio["Immigration"] = new Array();
    secondaryportfolio["Immigration"].push("Immigration");
    secondaryportfolio["Personal Loans"] = new Array();
    secondaryportfolio["Personal Loans"].push("Personal Loan");
    secondaryportfolio["Recoverable Grant"] = new Array();
    secondaryportfolio["Recoverable Grant"].push("Recoverable Grant");
    secondaryportfolio["Resilience Loans"] = new Array();
    secondaryportfolio["Resilience Loans"].push("PSP-Resilience Loans");
    secondaryportfolio["Resilience Loans"].push("Resilience Loans");
    secondaryportfolio["Other"] = new Array();
    secondaryportfolio["Other"].push("Other");
  }

  let primaryPortfolioOptionList: { id: string; name: any }[] = [];
  for (let key in primaryportfolio) {
    primaryPortfolioOptionList.push({ id: key, name: key });
    if (primaryportfolio[key]?.length) {
      for (let item of primaryportfolio[key]) {
        primaryPortfolioOptionList.push({
          id: key + "------" + item,
          name: "------" + item,
        });
      }
    }
  }

  let secondaryPortfolioOptionList: { id: string; name: any }[] = [];
  secondaryPortfolioOptionList.push({ id: "Select", name: "" });
  for (let key in secondaryportfolio) {
    secondaryPortfolioOptionList.push({ id: key, name: key });
    if (secondaryportfolio[key]?.length) {
      for (let item of secondaryportfolio[key]) {
        secondaryPortfolioOptionList.push({
          id: key + "------" + item,
          name: "------" + item,
        });
      }
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        if (isMenuStatsCacheExpired("loan", 3600000)) {
          await preloadMenuStats("loan");
        }
        const data = getCachedMenuStats("loan");
        setTotal(data ? data.data : 0);
      } catch (error) {
        console.error("Failed to load loan stats:", error);
        setTotal(0);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const initStatus = "OK";
  const [loanFilterData, setLoanFilterData] = useState(() => {
    const baseFilters = [
      <CustomFilterText label="App #" source="id" defaultValue="" />,
      <CustomFilterText label="User #" source="iUserId" defaultValue="" />,
      <CustomFilterText label="Loan #" source="sLoanNum" defaultValue="" />,
      <FilterErrorLoanStatus
        label="Loan Status"
        source="filterLoanStatus"
        before="and"
        disabled
      />,
      <FilterLoanAttention
        label="Attention"
        source="attention"
        before="and"
        disabled={false}
      />,
      <FilterLoanResetHistory
        label="Reset History"
        source="allModifyNum"
        before="and"
        disabled={initStatus == "OK" || initStatus == "Voided" ? true : false}
      />,
      <FilterProduct label="Product" source="product" before="and" />,
      <CustomFilterText
        label="Applicant Name"
        source="userName"
        defaultValue=""
      />,
      <CustomFilterText
        label="Applicant Email"
        source="userEmail"
        defaultValue=""
      />,
      <CustomFilterText label="Co-Applicant" source="coName" defaultValue="" />,
      <CustomFilterText
        label="Guarantor"
        source="guarantorName"
        defaultValue=""
      />,
      // <FilterLoanStatus label="Status" source="curStatus" before="and" />,
      <FilterAmountOriginalPrincipal
        label="Original Principal Amount"
        source="originalnoteamount"
        before="and"
      />,
      <FilterAmountPrincipal
        label="Remaining Principal Amount"
        source="activeprincipalbalance"
        before="and"
        status={initStatus}
      />,
      <FilterLastPaymentDate
        label="Last Payment Date"
        source="limitLastPaymentDate"
        before="and"
      />,
      <FilterPaymentFrequency
        label="Payment Frequency"
        source="paymentfrequency"
        disabled={
          initStatus == "Charged-Off" || initStatus == "Voided" ? true : false
        }
      />,
      <FilterNoteDate label="Note Date" source="limitNoteDate" before="and" />,

      <FilterMaturityDate
        label="Maturity Date"
        source="limitMaturityDate"
        before="and"
      />,
      <FilterRemainingTerm
        label={"Remaining Term"}
        source="remainingterm"
        before="and"
        disabled={
          initStatus == "OK" ||
          initStatus == "Paid-Off" ||
          initStatus == "Charged-Off" ||
          initStatus == "Voided"
            ? true
            : false
        }
      />,

      <FilterPaidOffDate
        label="Paid-Off Date"
        source="limitPaidOffDate"
        disabled={initStatus != "Paid-Off" ? true : false}
        before="and"
      />,
      <FilterChargedOffDate
        label="Charged-Off Date"
        source="limitChargedOffDate"
        disabled={initStatus != "Charged-Off" ? true : false}
        before="and"
      />,
      <FilterVoidedDate
        label="Voided Date"
        source="limitVoidedDate"
        disabled={initStatus != "Voided" ? true : false}
        before="and"
      />,

      <FilterCustomSelect
        label="Primary Portfolio"
        variant="outlined"
        source="PrimaryPortfolio"
        optionlist={primaryPortfolioOptionList}
        before="and"
        disabled={
          localBank == "springbankny" || localBank == "ntfcu" ? true : false
        }
      />,

      <FilterCustomSelect
        label="Secondary Portfolio"
        variant="outlined"
        source="SecondaryPortfolio"
        optionlist={secondaryPortfolioOptionList}
        before="and"
        disabled={
          localBank == "springbankny" || localBank == "ntfcu" ? true : false
        }
      />,
    ];
    if (authrole == "admin") {
      return [
        ...baseFilters,
        <FilterBank label="Institution" source="sBank" before="and" />,
      ];
    }
    return baseFilters;
  });

  const handleFilterStatusChange = (newStatus: string) => {
    const LoanListFilters = [
      <CustomFilterText label="App #" source="id" defaultValue="" />,
      <CustomFilterText label="User #" source="iUserId" defaultValue="" />,
      <CustomFilterText label="Loan #" source="sLoanNum" defaultValue="" />,
      <FilterErrorLoanStatus
        label="Loan Status"
        source="filterLoanStatus"
        before="and"
        disabled={
          newStatus == "Funding Source Removed" ||
          newStatus == "Insufficient Balance" ||
          newStatus == "Transfer Failed"
            ? false
            : true
        }
      />,
      <FilterLoanAttention
        label="Attention"
        source="attention"
        before="and"
        disabled={
          newStatus == "Funding Source Removed" ||
          newStatus == "Insufficient Balance" ||
          newStatus == "Transfer Failed" ||
          newStatus == "Paid-Off" ||
          newStatus == "Charged-Off" ||
          newStatus == "Voided"
            ? true
            : false
        }
      />,
      <FilterLoanResetHistory
        label="Reset History"
        source="allModifyNum"
        before="and"
        disabled={newStatus == "OK" || newStatus == "Voided" ? true : false}
      />,
      <CustomFilterText
        label="Applicant Name"
        source="userName"
        defaultValue=""
      />,
      <CustomFilterText
        label="Applicant Email"
        source="userEmail"
        defaultValue=""
      />,
      <CustomFilterText
        label="Co-Applicant Name"
        source="coName"
        defaultValue=""
      />,
      <CustomFilterText
        label="Guarantor Name"
        source="guarantorName"
        defaultValue=""
      />,
      <FilterAmountOriginalPrincipal
        label="Original Principal Amount"
        source="originalnoteamount"
        before="and"
      />,
      <FilterAmountPrincipal
        label="Remaining Principal Amount"
        source="activeprincipalbalance"
        before="and"
        status={newStatus}
      />,
      <FilterLastPaymentDate
        label="Last Payment Date"
        source="limitLastPaymentDate"
      />,
      <FilterPaymentFrequency
        label="Payment Frequency"
        source="paymentfrequency"
        disabled={
          newStatus == "Charged-Off" || newStatus == "Voided" ? true : false
        }
      />,
      <FilterNoteDate label="Note Date" source="limitNoteDate" />,
      <FilterMaturityDate label="Maturity Date" source="limitMaturityDate" />,
      <FilterRemainingTerm
        label={"Remaining Term"}
        source="remainingterm"
        before="and"
        disabled={
          newStatus == "OK" ||
          newStatus == "Paid-Off" ||
          newStatus == "Charged-Off" ||
          newStatus == "Voided"
            ? true
            : false
        }
      />,
      <FilterPaidOffDate
        label="Paid-Off Date"
        source="limitPaidOffDate"
        disabled={newStatus != "Paid-Off" ? true : false}
      />,
      <FilterChargedOffDate
        label="Charged-Off Date"
        source="limitChargedOffDate"
        disabled={newStatus != "Charged-Off" ? true : false}
      />,
      <FilterVoidedDate
        label="Voided Date"
        source="limitVoidedDate"
        disabled={newStatus != "Voided" ? true : false}
      />,
      <FilterCustomSelect
        label="Primary Portfolio"
        variant="outlined"
        source="PrimaryPortfolio"
        optionlist={primaryPortfolioOptionList}
        before="and"
        disabled={
          localBank == "springbankny" || localBank == "ntfcu" ? true : false
        }
      />,
      <FilterCustomSelect
        label="Secondary Portfolio"
        variant="outlined"
        source="SecondaryPortfolio"
        optionlist={secondaryPortfolioOptionList}
        before="and"
        disabled={
          localBank == "springbankny" || localBank == "ntfcu" ? true : false
        }
      />,
    ];
    if (authrole == "admin") {
      LoanListFilters.push(
        <FilterBank label="Institution" source="sBank" before="and" />
      );
    }
    setLoanFilterData(LoanListFilters);
  };

  return (
    <>
      <List
        actions={<LoanListActions />}
        filters={loanFilterData}
        sort={{ field: "id", order: "DESC" }}
        aside={
          <LoanListAside
            totalData={total}
            onChange={handleFilterStatusChange}
          />
        }
        pagination={<PostPagination />}
        exporter={customLoanExporter}
        perPage={25}
        sx={{
          width: "100%",
          borderRadius: "0px",
          "& .MuiCard-root": {
            borderRadius: "0px",
          },
          "& .RaList-actions form": {
            flex: "0 1 350%",
          },
          "& .RaList-actions form .filter-field .MuiInputBase-input": {
            width: "230px",
          },
          "& .RaList-actions .RaFilterForm-filterFormInput:first-child .MuiInputBase-root::before":
            {
              display: "none",
            },
          "& .RaList-actions .filter-field:first-child .MuiFormControl-root": {
            marginLeft: 0,
          },
        }}
        empty={
          <Typography className="no-results">
            <NoResults />
          </Typography>
        }
        emptyWhileLoading={false}
        loading={<HmLoading />}
      >
        <LoanFilterList />
      </List>
    </>
  );
};

const QuickFilter = ({ label }: InputProps) => {
  const translate = useTranslate();
  return <Chip sx={{ mb: 1 }} label={translate(label as string)} />;
};

export const LoanFilters = [
  <SearchInput source="q" alwaysOn />,
  <ReferenceInput
    source="category_id"
    reference="categories"
    sort={{ field: "id", order: "ASC" }}
  >
    <SelectInput source="name" />
  </ReferenceInput>,
  <NumberInput source="width_gte" />,
  <NumberInput source="width_lte" />,
  <NumberInput source="height_gte" />,
  <NumberInput source="height_lte" />,
  <QuickFilter
    label="resources.products.fields.stock_lte"
    source="stock_lte"
    defaultValue={10}
  />,
];

export default LoanList;
